import { Tab, TabBar, WorkflowIcon, Icon, StatusChip } from '@salecycle/ui-component-library';
import { useHistory } from 'react-router-dom';
import { ActiveTab } from 'sections/onsite-campaigns/context/OnsiteCampaignSectionState';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useCampaignSectionContext } from 'sections/onsite-campaigns/context/CampaignSectionContext';
import { useCampaignSettings } from '../tabs/CampaignWorkflowTab/state/CampaignSettings/hooks/useCampaignSettings';

interface Props {
  siteId: string;
  activeTab: ActiveTab;
}
const Container = styled.div`
  padding: 0 40px 0 40px;
  display: grid;
  grid-template-areas: 'rightSide centerSide leftSide';
  border-bottom: 1px solid #d6deea;
  > div + div {
    > div {
      > div {
        padding-top: 0;
      }
    }
  }
  @media (max-width: 768px) {
    grid-template-areas:
      'rightSide leftSide'
      'centerSide centerSide';
  }
`;

// const RightSide = styled.div`
//   display: flex;
//   justify-content: start;
//   align-items: center;
//   grid-area: rightSide;
//   button {
//     margin-left: 12px;
//   }
//   span {
//     width: 18px;
//     height: 18px;
//   }
// `; we need this in future

const CenterContent = styled.div`
  display: flex;
  grid-area: centerSide;
  justify-content: center;
`;

const LeftSide = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  grid-area: leftSide;
  min-width: 76px;
`;

export function CampaignTabs({ siteId, activeTab }: Props) {
  const { t } = useTranslation('campaigns');
  const { state: sectionContext } = useCampaignSectionContext();
  const { status, allowList } = useCampaignSettings();

  const history = useHistory();

  const campaignId = sectionContext?.selectedCampaign?.id;

  return (
    <Container>
      {/* <RightSide>
        <Tooltip position="top" title="Tooltip">
          <Avatar icon="question" iconSize="extra-small" bg="#0067E5" />
        </Tooltip>
        <LinkButton onClick={() => history.push(`/`)}>Help Guides</LinkButton> 
      </RightSide>  we need this in future */}
      <CenterContent>
        <TabBar topPadding={0}>
          <Tab
            selected={activeTab === ActiveTab.WORKFLOW_TAB}
            onClick={() => history.push(`/sites/${siteId}/campaigns/onsite/${campaignId}/workflow`)}
            padding="8px 16px 0  16px"
            margin="0 8px 0 0"
            hasIcon
          >
            <WorkflowIcon />
            <span>Workflow</span>
          </Tab>
          <Tab
            selected={activeTab === ActiveTab.SETTINGS_TAB}
            onClick={() => history.push(`/sites/${siteId}/campaigns/onsite/${campaignId}/settings`)}
            hasIcon
            padding="8px 16px 0  16px"
            margin="0 8px 0 0"
          >
            <Icon icon="cog" />
            <span>Settings</span>
          </Tab>
        </TabBar>
      </CenterContent>
      <LeftSide>
        {status === 'Test' && allowList ? (
          <StatusChip aria-label={'Current campaign status'} label={t('onsite.campaignStatus.test')} variation="Test" />
        ) : status === 'Draft' ? (
          <StatusChip
            aria-label={'Current campaign status'}
            label={t('onsite.campaignStatus.draft')}
            variation="Draft"
          />
        ) : (
          <StatusChip aria-label={'Current campaign status'} label={t('onsite.campaignStatus.live')} variation="Live" />
        )}
      </LeftSide>
    </Container>
  );
}
